'use client';
import React from 'react';
import { useCheckoutStore } from '../../store/checkoutStore';

export default function ErrorStep() {
  const { errorMessage, setStep, reset } = useCheckoutStore();

  return (
    <div className="flex flex-col items-center gap-6 py-4 animate-fade-in text-center">
      {/* Error icon */}
      <div className="w-20 h-20 rounded-full flex items-center justify-center"
        style={{ background: 'rgba(239, 68, 68, 0.1)', border: '2px solid rgba(239, 68, 68, 0.3)' }}>
        <svg className="w-10 h-10 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
      {/* Title */}
      <div className="flex flex-col gap-2">
        <h3 className="text-xl font-bold text-foreground">Verification Failed</h3>
        <p className="text-sm text-muted-foreground leading-relaxed max-w-xs mx-auto">
          {errorMessage || 'The transaction could not be verified. Please check your hash and try again.'}
        </p>
      </div>
      {/* Common causes */}
      <div className="w-full rounded-xl p-4 flex flex-col gap-3 text-left"
        style={{ background: 'rgba(239, 68, 68, 0.05)', border: '1px solid rgba(239, 68, 68, 0.2)' }}>
        <p className="text-xs font-semibold text-red-400 uppercase tracking-wider">Common causes</p>
        <ul className="flex flex-col gap-2">
          {[
            'Transaction hash is incorrect or incomplete',
            'Payment not yet broadcast to the Bitcoin network',
            'Insufficient confirmation count — wait a few minutes and retry',
            'Payment amount was less than required',
            'Payment was sent to the wrong wallet address',
          ]?.map((cause, i) => (
            <li key={`cause-${i}`} className="flex items-start gap-2 text-xs text-muted-foreground">
              <span className="text-red-400 flex-shrink-0 mt-0.5">·</span>
              {cause}
            </li>
          ))}
        </ul>
      </div>
      {/* Actions */}
      <div className="flex flex-col gap-3 w-full">
        <button
          onClick={() => setStep('awaiting_hash')}
          className="btn-primary w-full py-3.5 text-sm font-bold flex items-center justify-center gap-2"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Try a different hash
        </button>
        <button
          onClick={() => setStep('payment_instructions')}
          className="btn-secondary w-full py-3.5 text-sm font-semibold flex items-center justify-center gap-2"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to payment instructions
        </button>
        <button
          onClick={reset}
          className="text-xs text-muted-foreground hover:text-foreground transition-colors duration-150"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}